import {
  sensorsDepositStep1PageView,
  sensorsDepositPageBackClick,
  sensorsDepositStep2IBTPageTermsPopupConfirmClick,
  sensorsDepositPoPUPAdvancedKYCReqView,
  sensorsDepositPoPUPAdvancedKYCReqClick,
  sensorsDepositPopUpMinDepositUnmetView,
  sensorsDepositPopUpMinDepositUnmetClick,
  sensorsDepositPopUpCouponUnusableView,
  sensorsDepositPopUpCouponUnusableClick,
  sensorsDepositResultPageView,
  sensorsDepositRetryClick,
  sensorsDepositBackToHomePageClick,
} from '@/util/sensorsdata/util'
import { sensorsTrack } from '@/util/sensorsdata'
import { SENSORS_TRACK } from '@/util/sensorsdata/constant'

export default function sensorsHandler(eventName, params = {}) {
  switch (eventName) {
    case 'DEPOSIT_STEP2PAGE_JUMP_THIRD_PARTY':
      sensorsTrack(SENSORS_TRACK.EVENT_NAME.DEPOSIT_STEP2PAGE_JUMP_THIRD_PARTY, {
        account_info: params.account_info,
        order_id: params.order_id,
        deposit_method_number: params.deposit_method_number,
        payment_method_number: params.payment_method_number,
      })
      break
    case 'DEPOSIT_STEP1PAGE_VIEW':
      sensorsDepositStep1PageView()
      break
    case 'DEPOSITPAGE_BACK_CLICK':
      sensorsDepositPageBackClick({
        current_page_name: params.current_page_name ?? null,
        account_type: params.account_type ?? null,
        account_info: params.account_info ?? null,
      })
      break
    case 'DEPOSIT_STEP2_CCCHECKOUTPAGE_VIEW':
      sensorsTrack(SENSORS_TRACK.EVENT_NAME.DEPOSIT_STEP2_CCCHECKOUTPAGE_VIEW, {
        account_info: params.account_info ?? null,
        order_id: params.order_id ?? null,
        deposit_method_number: params.deposit_method_number ?? null,
        payment_method_number: params.payment_method_number ?? null,
      })
      break
    case 'DEPOSIT_STEP3_CCBRIDGERPAGE_VIEW':
      sensorsTrack(SENSORS_TRACK.EVENT_NAME.DEPOSIT_STEP3_CCBRIDGERPAGE_VIEW, {
        account_info: params.account_info ?? null,
        order_id: params.order_id ?? null,
        deposit_method_number: params.deposit_method_number ?? null,
        payment_method_number: params.payment_method_number ?? null,
      })
      break
    case 'DEPOSIT_STEP2_IBTPAGETERMSPOPUP_CONFIRM_CLICK':
      sensorsDepositStep2IBTPageTermsPopupConfirmClick({
        account_info: params.account_info ?? null,
        order_id: params.order_id ?? null,
        deposit_method_number: params.deposit_method_number ?? null,
        payment_method_number: params.payment_method_number ?? null,
        payment_method: params.payment_method ?? null,
      })
      break
    case 'DEPOSIT_POPUP_ADVANCEDKYCREQ_VIEW':
      sensorsDepositPoPUPAdvancedKYCReqView()
      break
    case 'DEPOSIT_POPUP_ADVANCEDKYCREQ_CLICK':
      sensorsDepositPoPUPAdvancedKYCReqClick({
        account_info: params.account_info ?? null,
        order_id: params.order_id ?? null,
        deposit_method_number: params.deposit_method_number ?? null,
        payment_method_number: params.payment_method_number ?? null,
        button_name: params.button_name ?? null,
      })
      break
    case 'DEPOSIT_POPUP_MINDEPOSITUNMET_VIEW':
      sensorsDepositPopUpMinDepositUnmetView({
        account_info: params.account_info ?? null,
        deposit_method_number: params.deposit_method_number ?? null,
      })
      break
    case 'DEPOSIT_POPUP_MINDEPOSITUNMET_CLICK':
      sensorsDepositPopUpMinDepositUnmetClick({
        account_info: params.account_info ?? null,
        deposit_method_number: params.deposit_method_number ?? null,
        payment_method_number: params.payment_method_number ?? null,
        button_name: params.button_name ?? null,
      })
      break
    case 'DEPOSIT_POPUP_MAXDEPOSITUNMET_VIEW':
      sensorsTrack(SENSORS_TRACK.EVENT_NAME.DEPOSIT_POPUP_MAXDEPOSITUNMET_VIEW, {
        account_info: params.account_info ?? null,
        deposit_method_number: params.deposit_method_number ?? null,
      })
      break
    case 'DEPOSIT_POPUP_MAXDEPOSITUNMET_CLICK':
      sensorsTrack(SENSORS_TRACK.EVENT_NAME.DEPOSIT_POPUP_MAXDEPOSITUNMET_CLICK, {
        account_info: params.account_info ?? null,
        deposit_method_number: params.deposit_method_number ?? null,
        payment_method_number: params.payment_method_number ?? null,
        button_name: params.button_name ?? null,
      })
      break
    case 'DEPOSIT_POPUP_COUPONUNUSABLE_VIEW':
      sensorsDepositPopUpCouponUnusableView({
        account_info: params.account_info ?? null,
        deposit_method_number: params.deposit_method_number ?? null,
        payment_method_number: params.payment_method_number ?? null,
        coupon_id: params.coupon_id ?? null,
        coupon_name: params.coupon_name ?? null,
        coupon_amount: params.coupon_amount ?? null,
        coupon_type: params.coupon_type ?? null,
      })
      break
    case 'DEPOSIT_POPUP_COUPONUNUSABLE_CLICK':
      sensorsDepositPopUpCouponUnusableClick({
        account_info: params.account_info ?? null,
        deposit_method_number: params.deposit_method_number ?? null,
        payment_method_number: params.payment_method_number ?? null,
        button_name: params.button_name ?? null,
        coupon_id: params.coupon_id ?? null,
        coupon_name: params.coupon_name ?? null,
        coupon_amount: params.coupon_amount ?? null,
        coupon_type: params.coupon_type ?? null,
      })
      break
    case 'DEPOSIT_RESULTPAGE_VIEW':
      sensorsDepositResultPageView({
        account_info: params.account_info ?? null,
        order_id: params.order_id ?? null,
        order_status: params.order_status ?? null,
        is_success: params.is_success ?? null,
        deposit_method_number: params.deposit_method_number ?? null,
        payment_method_number: params.payment_method_number ?? null,
      })
      break
    case 'DEPOSIT_RETRY_CLICK':
      sensorsDepositRetryClick({
        account_info: params.account_info ?? null,
        order_id: params.order_id ?? null,
        deposit_method_number: params.deposit_method_number ?? null,
        payment_method_number: params.payment_method_number ?? null,
        fail_reason: params.fail_reason,
      })
      break
    case 'DEPOSIT_BACKTOHOMEPAGE_CLICK':
      sensorsDepositBackToHomePageClick({
        account_info: params.account_info ?? null,
        deposit_method_number: params.deposit_method_number ?? null,
        payment_method_number: params.payment_method_number ?? null,
        fail_reason: params.fail_reason,
      })
      break
    case 'WITHDRAWAL_STEP2_SELECTBANKACCOUNT_SETTING':
      if (params.field_name) {
        sensorsTrack(SENSORS_TRACK.EVENT_NAME.WITHDRAWAL_STEP2_SELECTBANKACCOUNT_SETTING, {
          account_info: params.account_info ?? null,
          withdrawal_method_number: params.withdrawal_method_number ?? null,
          withdrawal_channel_number: params.withdrawal_channel_number ?? null,
          button_name: params.button_name || null,
          field_name: params.field_name || null,
        })
      }
      break
    default:
      break
  }
}
